import React, { useEffect, useState } from "react";
import { Avatar, Button, Typography, Card, Empty, Spin } from "antd";
import ProfileHeader from "../../Proflie/ProfileHeader";
import ExploreAgentCard from "../../Card/ExploreAgentCard";
import { TiArrowSortedDown } from "react-icons/ti";
import { getUserOrg } from "../../../api/user";
import { getUserTeams } from "../../../api/userApiFunctions";
import { getUserRole } from "../../../Utility/service";
import { getTeams } from "../../../api/team-admin";

const TeamAgents = ({
  assistantsByCategory,
  chatWithAssistant,
  addFavoriteAssistant,
  userId,
  handleLoadMore,
  searchQuery,
  selectAssistantType,
  handleCardClick,
  theme,
  featuredAssistants,
  loading,
  favoriteAssistant,
  setRefresh,
  setFavoriteAssistant,
  HeaderContentChildren,
  teamId,
  enablePersonalize = false,
}) => {

 
  const { Title } = Typography;
  const [userOrgId, setUserOrgId] = useState(null);
  const [teamIds, setTeamIds] = useState([]); 
  const role = getUserRole()

  // Fetch user organization ID
  useEffect(() => {
    const fetchUserOrg = async () => {
      if (userId) {
        const orgId = await getUserOrg(userId);
        setUserOrgId(orgId);
      } else {
        console.error("User ID is not provided");
      }
    };

    fetchUserOrg();
  }, [userId]);

  // Fetch user team IDs
  useEffect(() => {
    const fetchTeams = async () => {
      try {
        if (role === "admin") {
          const result = await getTeams(1, 100); 
  
          if (result?.success && Array.isArray(result.data)) {
            const extractedTeamIds = result.data.map((team) => team._id);
            setTeamIds(extractedTeamIds);
          } else {
            console.error(
              "[fetchTeams] Failed to fetch teams:",
              result?.error || "Invalid response format"
            );
          }
        } else {
          const result = await getUserTeams(userId);
  
          if (result?.success && Array.isArray(result.data)) {
            const extractedTeamIds = result.data.map((team) => team._id);
            setTeamIds(extractedTeamIds);
          } else {
            console.error(
              "[fetchUserTeams] Failed to fetch user teams:",
              result?.error || "Invalid response format"
            );
          }
        }
      } catch (error) {
        console.error("[fetchTeams] Unexpected error fetching teams:", error);
      }
    };
  
    fetchTeams();
  }, [userId, role]); // A

  return (
    <Spin spinning={loading}>
      <ProfileHeader title="Team Agents" subHeading="Explore your team's agents on the platform." />
      {HeaderContentChildren}

      <div className="mt-3">
        {featuredAssistants?.assistants?.length === 0 &&
        assistantsByCategory?.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          !loading && (
            <Title level={5}>
              {featuredAssistants?.assistants?.length ? "👑 Featured Agents" : ""}
            </Title>
          )
        )}
      </div>

      {/* Featured Agents */}
      <div className="assistant-container mt-3">
        {featuredAssistants?.assistants?.map((assistant) => (
          <ExploreAgentCard
            key={assistant.id}
            agent={assistant}
            chatWithAssistant={chatWithAssistant}
            addFavoriteAssistant={addFavoriteAssistant}
            userId={userId}
            handleCardClick={handleCardClick}
            favoriteAssistantData={favoriteAssistant}
            setRefresh={setRefresh}
            setFavoriteAssistant={setFavoriteAssistant}
            enablePersonalize={enablePersonalize}
          />
        ))}
      </div>

      <div className="load-more-container">
        {featuredAssistants?.assistants?.length > 0 &&
        featuredAssistants?.assistants?.length !== featuredAssistants?.totalAssistantCount && (
          <>
            <div className="load-more-button">
              <Button
                size="small"
                icon={<TiArrowSortedDown />}
                onClick={() => handleLoadMore({ categoryName: "featured" })}
              >
                Load More{" "}
              </Button>
            </div>
            <hr style={{ borderColor: "hsl(0, 0%, 80%)", marginTop: "24px" }} />
          </>
        )}
      </div>

      {/* Filter and display only team agents */}
      <div>
        {assistantsByCategory?.map((category, i) => {
         const filteredAssistants = category?.categoryInfo?.assistants?.filter((assistant) => {
          const assistantTeams = Array.isArray(assistant.teamId)
            ? assistant.teamId
            : assistant.teamId?.split(",") || [];
          if (assistantTeams.includes(teamId.trim())) {
            return true;
          } else {
            return false;
          }
        }) || [];
      
          return (
            <div key={category.categoryName}>
              {filteredAssistants.length > 0 ? (
                <Title className="my-3" level={5}>
                  {category?.categoryName}
                </Title>
              ) : (
                (searchQuery?.trim() || selectAssistantType?.trim()) && (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )
              )}
              <div className="assistant-container">
                {filteredAssistants.map((assistant) => (
                  <ExploreAgentCard
                    key={assistant.id}
                    agent={assistant}
                    chatWithAssistant={chatWithAssistant}
                    addFavoriteAssistant={addFavoriteAssistant}
                    userId={userId}
                    handleCardClick={handleCardClick}
                    favoriteAssistantData={favoriteAssistant}
                    setRefresh={setRefresh}
                    setFavoriteAssistant={setFavoriteAssistant}
                    enablePersonalize={enablePersonalize}
                  />
                ))}
              </div>
              <div className="load-more-container mt-1">
                {filteredAssistants.length > 0 &&
                filteredAssistants.length !== category.categoryInfo?.totalAssistantCount ? (
                  <>
                    <div className="load-more-button">
                      <Button
                        size="small"
                        icon={<TiArrowSortedDown />}
                        onClick={() => handleLoadMore(category)}
                      >
                        Load More
                      </Button>
                    </div>
                    <hr
                      style={{
                        borderColor: "hsl(0, 0%, 80%)",
                        marginTop: "24px",
                      }}
                    />
                  </>
                ) : null}
              </div>
            </div>
          );
        })}
        {assistantsByCategory?.assistants?.length === 0 && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>

      <span className="text-center w-100 d-block">There is no more data</span>
    </Spin>
  );
};

export default TeamAgents;
